// @ vendor
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../../constants/actionTypes');
const {
    CM_EUR_CURRENCY,
    CM_TRANSFER_TAX_EXEMPT_FALSE,
} = require('../../constants/constants');
const { INTERVENER_CODES_BY_DESCRIPTION } = require('constants/interveners');

function setInitialState() {
    return Immutable.fromJS({
        filteredFundsByAssociatedAccount: [],
        mustValidateMinimumAmount: false,
        mustDisplayMinimumAmountLabel: false,
        isFetchingContractsOriginTransfer: false,
        isContractsOriginTransferFetched: false,
        selectionFundsInfo: [],
        infoFondosTodos: false,
        showGeneralMinAmountMessage: false,
        valid: false,
        accountBalanceInvalid: false,
        accountNumber: '',
        accountNumberFromFilter: 0,
        accountNumberTransfer: '',
        interveners: Immutable.List(),
        availableInterveners: Immutable.List(),
        originalInterveners: Immutable.List(),
        amount: 0,
        missingTransferFundAmount: 0,
        minimumAmountIsValid: true,
        amountAccountIsValid: true,
        amountIsValid: true,
        amountDirty: false,
        amountMinimumIsValid: true,
        accountIsValid: true,
        validAmountFund: true,
        emptyAmount: false,
        isSelectedFund: true,
        isTransferFunds: true,
        isNextButtonDisabled: false,
        isTransferWithMoney: false,
        selectionFundsInfoEmpty: false,
        mustChangeAccount: true,
        customWallets: [],
        fetchingWallets: false,
        fetchingWalletsError: false,
        customMinimumPurchaseAmount: {
            amount: 0,
            currency: '',
        },
        originFundInfo: {},
        accountAmount: {
            amount: 0,
            currency: CM_EUR_CURRENCY,
        },
        selectedAccount: {
            productNumber: '',
            contractNumber: '',
        },
        oldFullContractNumber: '',
        walletFiltervalue: 0,
        originFundMatchedInPortfolio: '',
        originFundMatchedIsin: '',
    });
}

function getOriginFundInfo(originFundId, state) {
    const originFundsList = state.get('selectionFundsInfo');
    const originFundInfo = originFundsList.find(originFund => {
        return (
            originFund.getIn([
                'infoFondosOutput',
                'infoFondosPosicionGlobal',
                'contrato',
                'numeroContrato',
            ]) === originFundId
        );
    });
    return originFundInfo.get('infoFondosOutput');
}

function getAccountNumber(accounts, newState) {
    const originFundInfo = newState.get('originFundInfo');
    const originFundContractId = originFundInfo.getIn([
        'infoFondosPosicionGlobal',
        'cuentaAsociada',
        'numeroContrato',
    ]);
    return accounts
        .find(account => account.get('contractNumber') === originFundContractId)
        .get('accountId');
}

function findTransferFund(funds) {
    return funds
        ? funds.find(
              fund =>
                  fund.infoFondosOutput.transferTaxExempt !==
                  CM_TRANSFER_TAX_EXEMPT_FALSE,
          )
        : false;
}

function minimumAmountIsValid(immState) {
    const mustValidateMinimumAmount = immState.get('mustValidateMinimumAmount');
    const amount = parseFloat(immState.get('amount'));

    if (amount > 0) {
        if (!mustValidateMinimumAmount) {
            return true;
        }

        const minimumAmount = parseFloat(
            immState.getIn(['customMinimumPurchaseAmount', 'amount']),
        );
        return amount >= minimumAmount;
    }

    return false;
}

function validateTransferWithMoneyStep(originFundId, state) {
    const isSelectedFund = !!originFundId;
    const amount = parseFloat(state.get('amount'));
    const emptyAmount = amount === 0;
    const accountBalance = parseFloat(state.getIn(['accountAmount', 'amount']));
    const validAccount = state.get('accountNumber') ? true : false;
    const accountBalanceInvalid = accountBalance <= 0;
    const validAmountMinimum = minimumAmountIsValid(state);
    const ready = validAmountMinimum && validAccount && isSelectedFund;

    return state.merge({
        valid: ready,
        isSelectedFund: isSelectedFund,
        amountDirty: false,
        amountIsValid: validAmountMinimum,
        validAmountFund: true,
        minimumAmountIsValid: validAmountMinimum,
        emptyAmount,
        accountIsValid: !!state.get('accountNumber'),
        showGeneralMinAmountMessage: true,
        amountAccountIsValid: true,
        accountBalanceInvalid: accountBalanceInvalid,
    });
}

function filterFundsByAssociatedAccount(associatedAccountNumber, state) {
    return state
        .get('selectionFundsInfo')
        .filter(
            fund =>
                fund.getIn([
                    'infoFondosOutput',
                    'infoFondosPosicionGlobal',
                    'cuentaAsociada',
                    'numeroContrato',
                ]) === associatedAccountNumber,
        );
}

function validateFromFundsStep(originFundId, state) {
    const amount = parseFloat(state.get('amount'));
    const isSelectedFund = !!originFundId;
    let validAmountMinimum = false;
    let validAmountFund = false;
    let value = 0;
    const emptyAmount = amount === 0;

    const originFundsList = state.get('selectionFundsInfo');
    const originFundInfo = originFundsList.find(originFund => {
        return (
            originFund.getIn([
                'infoFondosOutput',
                'infoFondosPosicionGlobal',
                'contrato',
                'numeroContrato',
            ]) === originFundId
        );
    });

    if (originFundInfo) {
        value = originFundInfo.getIn([
            'infoFondosOutput',
            'infoFondosPosicionGlobal',
            'importes',
            'total',
            'valor',
            'importeEur',
            'importe',
        ]);
        validAmountMinimum = minimumAmountIsValid(state);
        validAmountFund = amount > 0 && amount <= value;
    }

    const ready = validAmountMinimum && validAmountFund && isSelectedFund;

    return state.merge({
        valid: ready,
        isSelectedFund: isSelectedFund,
        amountDirty: false,
        amountIsValid: validAmountFund && validAmountMinimum,
        validAmountFund: validAmountFund,
        missingTransferFundAmount: amount - value,
        minimumAmountIsValid: validAmountMinimum,
        emptyAmount,
        accountIsValid: !!state.get('accountNumber'),
        showGeneralMinAmountMessage: true,
        amountAccountIsValid: true,
        accountBalanceInvalid: false,
    });
}

function validateStep(state) {
    const amount = parseFloat(state.get('amount'));
    const accountBalance = parseFloat(state.getIn(['accountAmount', 'amount']));
    const validAccount = state.get('accountNumber');

    const validAmountMinimum = minimumAmountIsValid(state);

    const validAmountAccount = amount > 0 && amount <= accountBalance;
    const emptyAmount = amount === 0;

    const accountBalanceInvalid = accountBalance <= 0;

    const ready =
        validAmountMinimum &&
        validAmountAccount &&
        validAccount &&
        !accountBalanceInvalid;

    return state.merge({
        valid: ready,
        accountBalanceInvalid: accountBalanceInvalid,
        amountDirty: false,
        amountIsValid: validAmountAccount && validAmountMinimum,
        amountAccountIsValid: validAmountAccount,
        minimumAmountIsValid: validAmountMinimum,
        emptyAmount,
        accountIsValid: !!state.get('accountNumber'),
        showGeneralMinAmountMessage: true,
        validAmountFund: true,
    });
}

function filterAvailables(currentInterveners = [], originalInterveners = []) {
    const availableInterveners = originalInterveners.filter(intervener => {
        return !currentInterveners.find(originalIntervener => {
            return intervener.get('name') === originalIntervener.get('name');
        });
    });

    return availableInterveners;
}

function parseInterveners(interveners) {
    return interveners.map(intervener => {
        return {
            name: intervener.nombre.trim(),
            surname: intervener.surname ? intervener.surname.trim() : '',
            type: intervener.desIntervencion.trim(),
            originalType: intervener.desIntervencion.trim(),
            interventionType: intervener.tipoIntervencion,
            interventionForm: intervener.formaIntervencion,
            documentNumber: intervener.numDocumento,
            documentType: intervener.tipoDocumento,
            personNumber: intervener.numPersona,
            personType: intervener.tipPers,
        };
    });
}

function cmWalletBuyStep1(state = setInitialState(), action) {
    let isTransferWithMoney;
    switch (action.type) {
        case actionTypes.CM_FILTER_BY_ASSOCIATED_ACCOUNT:
            return state.merge({
                filteredFundsByAssociatedAccount: filterFundsByAssociatedAccount(
                    action.payload.associatedAccountNumber,
                    state,
                ),
                accountNumberFromFilter: action.payload.accountId,
            });
        case actionTypes.CM_FROM_FUNDS_VALIDATE_STEP:
            return validateFromFundsStep(action.payload.originFund, state);
        case actionTypes.CM_TRANSFER_MONEY_VALIDATE_STEP:
            return validateTransferWithMoneyStep(
                action.payload.originFund,
                state,
            );
        case actionTypes.CM_VALIDATE_STEP:
            return validateStep(state);
        case actionTypes.CM_SET_TYPE:
            return state.merge({
                type: action.payload.type,
            });
        case actionTypes.FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_REQUEST:
            return state.merge({
                isFetchingContractsOriginTransfer: true,
            });
        case actionTypes.CM_SET_ACCOUNT_CHANGED:
            return state.merge({
                mustChangeAccount: false,
            });
        case actionTypes.CM_BUY_TYPE_CHANGED:
            return state.merge({
                mustChangeAccount: true,
            });
        case actionTypes.CM_GET_PORTFOLIOS_LIST_REQUEST:
            return state.set('fetchingWallets', true);
        case actionTypes.CM_GET_PORTFOLIOS_LIST_ERROR:
            return state.merge({
                fetchingWallets: false,
                fetchingWalletsError: true,
            });
        case actionTypes.CM_GET_PORTFOLIOS_LIST_SUCCESS:
            return state.merge({
                fetchingWallets: false,
                fetchingWalletsError: false,
                customWallets: action.payload,
            });
        case actionTypes.CM_SET_FUND_ID_MATCHED_IN_PORTFOLIO:
            return state.merge({
                originFundMatchedInPortfolio: action.payload.fundId,
                originFundMatchedIsin: action.payload.portfolioIsin,
            });
        case actionTypes.CM_FILTER_CHANGE_WALLET:
            const selectedWallet = state
                .get('customWallets')
                .find(
                    wallet =>
                        wallet.get('idPortfolioAccount') === action.payload,
                );
            const selectedWalletCount = selectedWallet
                ? selectedWallet.get('count')
                : null;
            return state.merge({
                walletFiltervalue: action.payload,
                walletFilterCount: selectedWalletCount,
            });
        case actionTypes.FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_SUCCESS:
            const infoFondosSeleccion = action.payload.data.infoFondosSeleccion;
            const selectionFundsInfoEmpty = !infoFondosSeleccion
                ? true
                : infoFondosSeleccion.length === 0
                ? true
                : false;
            return state.merge({
                isFetchingContractsOriginTransfer: false,
                isContractsOriginTransferFetched: true,
                isTransferFunds: findTransferFund(
                    action.payload.data.infoFondosSeleccion,
                ),
                selectionFundsInfo: infoFondosSeleccion,
                infoFondosTodos: action.payload.data.infoFondosTodos,
                selectionFundsInfoEmpty: selectionFundsInfoEmpty,
            });
        case actionTypes.CM_GET_INTERVENERS_SUCCESS: {
            const nextInterveners = Immutable.fromJS(
                parseInterveners(action.payload.data.intervinientes.dato),
            );
            const interveners = {
                interveners: Immutable.List(nextInterveners),
                originalInterveners: Immutable.List(nextInterveners),
            };
            const newState = state.merge(interveners);
            return newState.merge({
                isFetching: false,
            });
        }
        case actionTypes.CM_RESTORE_DEFAULT_INTERVENERS:
            return state.mergeDeep({
                interveners: action.payload.originalInterveners,
                availableInterveners: Immutable.List(),
            });
        case actionTypes.CM_SET_ACCOUNT_INTERVENER_NAME: {
            let interveners = state.get('interveners');
            const nextInterveners = interveners.setIn(
                [action.payload.index, 'name'],
                action.payload.name,
            );
            const availableInterveners = filterAvailables(
                nextInterveners,
                action.payload.originalInterveners,
            );

            return state.mergeDeep({
                interveners: nextInterveners,
                availableInterveners,
            });
        }
        case actionTypes.CM_SET_ACCOUNT_INTERVENER_TYPE:
            return state
                .setIn(
                    ['interveners', action.payload.index, 'type'],
                    action.payload.type,
                )
                .setIn(
                    ['interveners', action.payload.index, 'interventionType'],
                    INTERVENER_CODES_BY_DESCRIPTION[action.payload.type],
                );
        case actionTypes.CM_SET_ACCOUNT:
            return state.mergeDeep({
                oldFullContractNumber: action.payload.oldFullContractNumber,
                accountNumber: action.payload.accountId,
                accountAmount: { amount: action.payload.accountAmount },
                selectedAccount: {
                    productNumber: action.payload.productNumber,
                    contractNumber: action.payload.contractNumber,
                },
            });
        case actionTypes.CM_DISABLE_NEXT_BUTTON:
            return state.merge({
                isNextButtonDisabled: true,
            });
        case actionTypes.CM_ENABLE_NEXT_BUTTON:
            return state.merge({
                isNextButtonDisabled: false,
            });
        case actionTypes.CM_SET_AMOUNT:
            const originFundAmount = state.getIn([
                'originFundInfo',
                'infoFondosPosicionGlobal',
                'importes',
                'total',
                'valor',
                'importeEur',
                'importe',
            ]);
            isTransferWithMoney =
                action.payload.amount - originFundAmount > 0 &&
                originFundAmount >= 0;
            return state.merge({
                amount: action.payload.amount,
                amountDirty: true,
                showGeneralMinAmountMessage: true,
                validAmountFund: true,
                isTransferWithMoney: isTransferWithMoney,
                missingTransferFundAmount:
                    action.payload.amount - originFundAmount,
            });
        case actionTypes.CM_SET_INITIAL_AMOUNT:
            return state.merge({
                amount: action.payload.amount,
                showGeneralMinAmountMessage: action.payload.amount > 0,
            });
        case actionTypes.CM_SAVE_ORIGIN_FUND_INFO:
            isTransferWithMoney = action.payload.missingTransferFundAmount > 0;
            let newState = state.set(
                'originFundInfo',
                getOriginFundInfo(action.payload.originFundId, state),
            );
            return newState
                .set(
                    'accountNumberTransfer',
                    getAccountNumber(action.payload.immAccounts, newState),
                )
                .set(
                    'missingTransferFundAmount',
                    action.payload.missingTransferFundAmount,
                )
                .set('isTransferWithMoney', isTransferWithMoney)
                .set('mustChangeAccount', true);

        default:
            return state;
    }
}

module.exports = cmWalletBuyStep1;
